import { Loader2, type LucideProps } from "lucide-react";
import * as React from "react";

import { cn } from "../lib/cn";

export interface SpinnerProps extends LucideProps {
  /** Accessible name announced to assistive technology while loading. */
  readonly label?: string;
}

/** Indeterminate loading indicator. Announced as a polite status. */
export const Spinner = React.forwardRef<SVGSVGElement, SpinnerProps>(
  ({ className, label = "Loading", ...props }, ref) => (
    <Loader2
      ref={ref}
      role="status"
      aria-label={label}
      className={cn("size-4 shrink-0 animate-spin", className)}
      {...props}
    />
  ),
);
Spinner.displayName = "Spinner";
